
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ToggleComponent',
  props: {
    value: Boolean,
  },
});
